import { FC, useRef, useState } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Pencil, X } from 'lucide-react';
import { CLASS_ICON_NAMES, ClassIcon } from './classIcons';

interface Props {
  value: string | null;
  onChange: (iconName: string) => void;
  label?: string;
}

const ClassIconPicker: FC<Props> = ({ value, onChange, label = 'Change class icon' }) => {
  const overlay = useRef<OverlayPanel>(null);
  const [isOpen, setIsOpen] = useState(false);
  const Selected = ClassIcon(value);

  const choose = (iconName: string) => {
    onChange(iconName);
    overlay.current?.hide();
  };

  return (
    <div className="nc_icon-picker">
      <button
        type="button"
        id="classIconPicker"
        className={`nc_icon-picker__avatar ${isOpen ? 'nc_icon-picker__avatar--selected' : ''}`}
        aria-label={label}
        aria-haspopup="dialog"
        onClick={event => overlay.current?.toggle(event)}
      >
        <Selected width={56} height={56} aria-hidden="true" />
        <span className="nc_icon-picker__edit" aria-hidden="true">
          <Pencil size={14} />
        </span>
      </button>

      <OverlayPanel
        ref={overlay}
        className="nc_icon-picker__panel"
        onShow={() => setIsOpen(true)}
        onHide={() => setIsOpen(false)}
      >
        <div className="nc_icon-picker__head">
          <span className="nc_icon-picker__title">Choose an icon</span>
          <button type="button" aria-label="Close" onClick={() => overlay.current?.hide()}>
            <X size={16} aria-hidden="true" />
          </button>
        </div>

        <ul className="nc_icon-picker__grid">
          {CLASS_ICON_NAMES.map(iconName => {
            const Icon = ClassIcon(iconName);
            const isSelected = iconName === value;

            return (
              <li key={iconName}>
                <button
                  type="button"
                  className={`nc_icon-picker__option ${isSelected ? 'nc_icon-picker__option--selected' : ''}`}
                  aria-pressed={isSelected}
                  aria-label={iconName.replace(/-/g, ' ')}
                  onClick={() => choose(iconName)}
                >
                  <Icon width={44} height={44} aria-hidden="true" />
                </button>
              </li>
            );
          })}
        </ul>
      </OverlayPanel>
    </div>
  );
};

export default ClassIconPicker;
